import WboDrawerTools from '@/components/common/ed-board/ed-board-tools/ed-wbo-drawer/wbo-drawer-tools';
import { BoardActionType } from './board-actions.model';

export default class EdWboDrawerRecreateShapes {

    private readonly MASS_ANNOTATION_DELETION_DELAY = 200;
    private wboDrawerTools: WboDrawerTools;

    private moveAnnotation(annotationId: number, deltaX: number, deltaY: number): void {
        let movementData = {
            id: annotationId,
            type: BoardActionType.UPDATE,
            deltax: deltaX,
            deltay: deltaY,
        };
        this.wboDrawerTools.drawAndSend(movementData, this.wboDrawerTools.list.Hand, false);
    }

    public processBoardAction(boardActionType: BoardActionType, annotation: any, children: any[]): void {
        switch (boardActionType) {
            case BoardActionType.ADD: {
                if (annotation.tool === 'Straight line') {
                    this.wboDrawerTools.drawAndSend(annotation, this.wboDrawerTools.list[annotation.tool], false);
                }

                else if (annotation.tool === 'Pencil') {
                    setTimeout(() => {
                        this.wboDrawerTools.drawAndSendSeveralAnnotations(this.wboDrawerTools.list[annotation.tool],
                            annotation, children, true, () => {
                            this.wboDrawerTools.updateBoardWorkInProgress(false);
                        });
                    });
                }

                else if ((annotation.tool !== 'Hand') && (annotation.deltax != null) && (annotation.deltay != null)) {
                    this.moveAnnotation(annotation.id, annotation.deltax, annotation.deltay);
                    return;
                }

                break;
            }

            
            case BoardActionType.DELETE:
                this.wboDrawerTools.drawAndSend(annotation, this.wboDrawerTools.list.Eraser, false);
                break;

            case BoardActionType.UPDATE:
                this.moveAnnotation(annotation.id, annotation.deltax, annotation.deltay);
                break;

            default:
                break;
        }
    }

    public processSeveralAnnotations(boardActionType: BoardActionType, annotations: any[], annotationsChildren: Map<string, any[]>) {
        this.wboDrawerTools.updateBoardWorkInProgress(true);

        for (let index = 0; index < annotations.length; index++) {

            const annotation = annotations[index];
            const children: any[] = annotationsChildren.get(annotation.id);
            const lastAnnotation = index === annotations.length - 1;
            const tool = BoardActionType.DELETE === boardActionType ? this.wboDrawerTools.list.Eraser : this.wboDrawerTools.list[annotation.tool];

            setTimeout(() => {
                this.wboDrawerTools.drawAndSendSeveralAnnotations(tool, annotation, children, lastAnnotation, () => {
                    setTimeout(() => this.wboDrawerTools.updateBoardWorkInProgress(false), this.MASS_ANNOTATION_DELETION_DELAY * annotations.length);
                });
            });
        }
    }


    constructor(wboDrawerTools: WboDrawerTools) {
        this.wboDrawerTools = wboDrawerTools;
    }
}